import { useEffect, useState } from "react";
import {
  getReferenceDataSyncSystems,
  StandaloneSyncSystem,
} from "../api/datasystems";

/** Providers eligible for this CRM, never a previous selection or a global fallback. */
export function useReferenceDataSyncSystems(crmSystemId?: number) {
  const [result, setResult] =
    useState<{ crmSystemId: number; systems: StandaloneSyncSystem[] }>();
  useEffect(() => {
    let ignore = false;
    setResult(undefined);
    if (!crmSystemId) return;
    getReferenceDataSyncSystems(crmSystemId)
      .then((systems) => {
        if (!ignore) setResult({ crmSystemId, systems });
      })
      .catch((err) => {
        if (!ignore) {
          setResult(undefined);
          console.error(err);
        }
      });
    return () => {
      ignore = true;
    };
  }, [crmSystemId]);
  return result?.crmSystemId === crmSystemId ? result?.systems || [] : [];
}
